<template>
  <FormModal v-if="showPopup" :closePopup="closePopup" />

  <div>
    <Navbar @click="handleNavbarLinkClick" :openPopup="openPopup" />
    <IndustriesAbout :data="ApiData" />
    <Funfacts/>
    <IndustriesService :data="ApiData?.servicesOffered"/>
    <IndustriesDevelopmentProcess :data="ApiData?.DevelopmentProcesses" />
    <IndustriesRequestDemo :data="ApiData?.requestDemo" />
    <IndustriesDiffcompany :data="ApiData?.differentOtherCompanies"/>
    <IndustriesOffers :data="ApiData?.Industries_offers" />
    <AppScreens />
    <Faq />
    <iframe frameborder="0" style="height:500px;width:99%;border:none;" src='https://forms.zohopublic.in/meandersoftwarecontact/form/ClientNeedsAssessmentForm/formperma/4fjH7ZBQUI7rdg6ZqA85n4ldQD4ajNkC_-RXMdrXXPs'></iframe>
    <FooterStyleFour />
  </div>
</template>

<script>
import Navbar from "../../Layout/Navbar";
import IndustriesAbout from "./IndustriesAbout";
import AppScreens from "../../HomeOne/AppScreens";
import Faq from "../../Faq/Faq";
import FooterStyleFour from "../../Layout/FooterStyleFour";
import axios from "axios";
import IndustriesStats from "./IndustriesStats";
import IndustriesRequestDemo from "./IndustriesRequestDemo";
import IndustriesDevelopmentProcess from "./IndustriesDevelopmentProcess.vue";
import IndustriesOffers from "./IndustriesOffers";
import IndustriesDiffcompany from "./IndustriesDiffcompany";
import IndustriesService from './IndustriesService.vue'
import FormModal from "../../HomeThree/FormModal.vue";
import Funfacts from "../../AboutOne/Funfacts.vue";
import { watchEffect } from "vue";
import { provideApolloClient } from '@vue/apollo-composable'
import apolloClient from '../../../apollo'
import { useGetIndustryById, useGetIndustryBySlug } from '../../../services/industriesService';
export default {
  name: "IndustriesClone",
  components: {
    Navbar,
    IndustriesAbout,
    IndustriesStats,
    IndustriesRequestDemo,
    AppScreens,
    Faq,
    FooterStyleFour,
    IndustriesDevelopmentProcess,
    IndustriesOffers,
    IndustriesDiffcompany,
    IndustriesService,
    FormModal,
    Funfacts
},
  data() {
    return {
      baseUrl: "https://content.meander.software/",
      ApiData: {},
      service:[],
      isLoading: false,
      showPopup:false
    };
  },
 
  async mounted() {
    await this.getData();
  },
  methods: {
      openPopup() {
      this.showPopup = true;
    },
    closePopup() {
      this.showPopup = false;
    },
    async getData() {
  const slug = this.$route.params.slug;
 
  
  try {
    provideApolloClient(apolloClient)(() => {
    const { result, loading, error } = useGetIndustryBySlug(slug);
    
    watchEffect(() => {
      // More comprehensive null check
      if (result.value?.industries && Array.isArray(result.value.industries)) {
        // Safely access the first item
        const firstIndustry = result.value.industries[0];
        
        if (firstIndustry) {
          this.ApiData = firstIndustry;
          
          // Safely access meta_tag with optional chaining
          const metaTag = firstIndustry?.meta_tag?.[0];
          const description = metaTag?.description;
          this.title = metaTag?.title || "Industry";
          
          document.title = this.title;
          
          // Update or create meta description tag
          const metaDescription = document.querySelector('meta[name="description"]');
          if (description) {
            if (metaDescription) {
              metaDescription.content = description;
            } else {
              const newMetaTag = document.createElement('meta');
              newMetaTag.name = 'description';
              newMetaTag.content = description;
              document.head.appendChild(newMetaTag);
            }
          }
        }
      } else {
        this.ApiData = null;
        console.warn('No industry data found for slug:', slug);
        
        // Set default title if no data
        document.title = "Industry";
      }
    });
  });
     

  } catch (error) {
    console.error('Error in getData:', error);
    this.ApiData = null;
    document.title = "Industry";
  }
},
async handleNavbarLinkClick(event) {
  
  
      this.isLoading = true
      if (event?.target?.href?.includes('industries')) {
        await this.getData();
      }
      
      this.isLoading = false
    },
  },
};
</script>
